$(function() {
  fitvids('.jonnitto-plyr-container');
});